
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  NRCandidate,
  NREducation,
  NRWork,
  NRProject,
  NRProjectCase,
  NRProjectShortVideoCase
} from "@/lib/model/NRXQ/candidate";
import dayjs from "dayjs";
import { NRClientType, AtsCompany, CV } from "@/lib/model/NRXQ/nr";

import { ExamInfo } from "@/lib/model/exam/candidate";
import request from "@/lib/request/request";
import config from "@/config/config";
import NRProjectEdit from "@/views/nr/components/nr-project-edit.vue";
import NRAttachmentEdit from "@/views/nr/components/nr-attachment-edit.vue";
import UploadCv from "@/views/nr/components/upload-cv.vue";
import { ElForm } from "element-ui/types/form";
import Auth from "@/lib/common/auth";

@Component({ components: { NRProjectEdit, NRAttachmentEdit, UploadCv } })
export default class AtsCV extends Vue {
  @Prop({ type: Number, default: 0 }) cvId!: number;
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType = NRClientType.NRClientTypeAdmin;

  submitting = false;
  edit = false; // 编辑简历状态
  editTab2 = false; //第三页tab编辑状态
  activeTab = 0; // 当前TAB页
  showAddInterview = false; //显示添加面试窗口
  selectExamId = null; //当前选择的考试
  sendMessage = true; //是否给候选人发信息
  atsCompanyList?: AtsCompany[] = [];
  examList: ExamInfo[] | null = [];
  nrToken = "";
  showUploadCv = false;
  dialogVisible = true;
  API_SUCCESS = 0;
  similarCvList: NRCandidate[] = [];

  showCopyDialog = false;
  copyMessageContent = "";
  showCopyMessageContent = ""; //展示用

  // 推荐相关
  recommendMessage = "";
  recommendStatus = 0;
  showRecommendDialog = false;
  showSyncCvDialog = false;

  ossPrefix = "";
  showSimilarCv = false;
  cvSyncSrc: NRCandidate | null = null;

  uploadedUrl = "";
  showBigImg = false;
  bigImgUrl = "";

  // 数据字典
  gender = ["男", "女"];
  positionTypeList = [
    {
      name: "主播",
      value: 1
    },
    {
      name: "编导",
      value: 2
    },
    {
      name: "直播运营",
      value: 3
    }
  ];

  modal = false;
  cv = new NRCandidate();
  cvTitleFormRules = {
    atsCompanyId: [
      { required: true, message: "请选择应聘公司", trigger: "blur" }
    ],
    position: [{ required: true, message: "请输入应聘岗位", trigger: "blur" }],
    positionType: [
      { required: true, message: "请选择应聘岗位类型", trigger: "blur" }
    ]
  };

  showWarn = false;
  showSuccess = false;
  selectedStatus = "";
  resumeType = "2"; // 1 = 原始简历 2 = 标准简历
  showCancelRecommendDialog = false;

  searchInputValue = ""; //搜索面试名称

  get showCompanySelect() {
    return this.clientType === NRClientType.NRClientTypeAdmin;
  }

  companyName(companyId: any) {
    if (this.atsCompanyList) {
      for (const item of this.atsCompanyList) {
        if (item.atsCompanyId == companyId) {
          return item.name;
        }
      }
    }
    return "";
  }

  get positionTypeName() {
    if (this.positionTypeList) {
      for (const item of this.positionTypeList) {
        if (item.value == this.cv.positionType) {
          return item.name;
        }
      }
    }
    return "";
  }
  //下拉搜索匹配
  get getOptions() {
    if (this.searchInputValue) {
      const t =
        this.examList?.filter(d => d.name.includes(this.searchInputValue)) ||
        [];
      return [...t];
    } else {
      return this.examList || [];
    }
  }

  //编辑时 默认一个经历占位
  @Watch("edit", { immediate: true })
  setLeastOneCv(n: any, o: any) {
    if (n && this.cv.cvWork.length === 0) {
      this.addWork();
    }
    if (n && this.cv.cvEducation.length === 0) {
      this.addEducation();
    }
  }

  async created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.atsCompanyList = await AtsCompany.getCompanyList();
    this.examList = await ExamInfo.getList();
  }

  async mounted() {
    if (!this.cvId) {
      this.edit = true;
    } else {
      this.edit = false;
      this.cv.atsCvId = this.cvId;
      this.cv = await this.getCv();
      console.log(this.cv);
      this.ossPrefix = this.cv.ossPrefix;
    }
    console.log(this.edit);
  }

  showDetail(cv: any) {
    window.open(
      `/ats-cv?companyId=${parseInt(Auth.companyId)}&cvId=${cv.atsCvId}`
    );
  }

  showSyncCv(cv: NRCandidate) {
    this.cvSyncSrc = cv;
    console.log(this.cvSyncSrc);
    this.showSyncCvDialog = true;
  }

  confirmSync() {
    if (this.cvSyncSrc) {
      const param = {
        sourceAtsCvId: this.cvSyncSrc.atsCvId,
        targetAtsCvId: this.cv.atsCvId
      };
      request.post("aiExam/atsAdmin/cvSync", param).then((res: any) => {
        if (res.data.code == 0) {
          this.getCv();
          this.showSyncCvDialog = false;
          this.showSimilarCv = false;
        }
      });
    }
  }

  async getSimilarCv() {
    if (this.clientType == NRClientType.NRClientTypeAdmin && this.cv.phone) {
      const param = {
        showNameOrPhone: this.cv.phone,
        IgnoreAtsCvIdList: [this.cv.atsCvId]
      };
      request.post("/aiExam/atsAdmin/cvList", param).then((res: any) => {
        if (res.data.code == 0 && res.data.data && res.data.data.list) {
          const similarCvList = [];
          for (const item of res.data.data.list) {
            similarCvList.push(new NRCandidate().assign(item));
          }
          this.similarCvList = similarCvList;
        }
      });
    }
  }

  showCopyMessageDialog() {
    this.copyMessageContent = "";

    if (this.cv.candidateConnectUrl) {
      this.copyMessageContent += `请点此链接完成面试：\n${this.cv.candidateConnectUrl}\n\n`;
      this.showCopyMessageContent += `<b>请点此链接完成面试：</b>\n${this.cv.candidateConnectUrl}\n\n`;
    }
    if (this.cv.canUpdateNrProject && this.cv.canUpdateNrProject == 1) {
      this.copyMessageContent += `请点此链接填写过往案例：\n${this.getEditHistoryUrl()}\n\n`;
      this.showCopyMessageContent += `<b>请点此链接填写过往案例：</b>\n${this.getEditHistoryUrl()}\n\n`;
    }
    if (this.cv.canUpdateNrAttachment && this.cv.canUpdateNrAttachment == 1) {
      this.copyMessageContent += `请点此链接上传过程文件：\n${this.getEditAttachmentUrl()}`;
      this.showCopyMessageContent += `<b>请点此链接上传过程文件：</b>\n${this.getEditAttachmentUrl()}`;
    }
    this.showCopyDialog = true;
  }
  //弹窗展示链接
  get copyMessageContentShowText() {
    return this.showCopyMessageContent.replace(/\n/g, "<br/>");
  }

  copyMessage() {
    const oInput = document.createElement("textarea");
    oInput.value = this.copyMessageContent;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    oInput.style.display = "none";
    document.body.removeChild(oInput);
    this.$message.success("复制成功");
  }

  getEditHistoryUrl() {
    return `${config.nrHost}/public/edit?id=${this.cv.atsCvOutId}&type=0`;
  }

  getEditAttachmentUrl() {
    return `${config.nrHost}/public/edit?id=${this.cv.atsCvOutId}&type=1`;
  }

  addInterview() {
    if (this.submitting) return;

    if (!this.selectExamId) {
      this.$message.error("请选择AI面试");
      return;
    }

    this.submitting = true;
    const param = {
      atsCvId: this.cv.atsCvId,
      examId: this.selectExamId,
      sendMessage: this.sendMessage ? 1 : 0
    };
    request
      .post("/aiExam/atsAdmin/cvCreateAi", param)
      .then(async resp => {
        if (resp.data.code === 0) {
          await this.getCv();
          this.showAddInterview = false;
        }
      })
      .finally(() => {
        this.submitting = false;
      });
  }

  async getCv() {
    console.log(this.cv.atsCvId);
    if (this.cv.atsCvId)
      this.cv = await NRCandidate.get(this.cv.atsCvId, this.clientType);
    console.log(this.cv);
    this.getSimilarCv();
    return this.cv;
  }

  //点击编辑
  editIt() {
    this.edit = true;
    this.editTab2 = this.activeTab == 2 ? true : false;
  }

  openLink(link: string) {
    window.open(link);
  }

  openResumeLink() {
    let url = this.uploadedUrl;
    if (this.cv.ossPrefix)
      url = this.cv.ossPrefix + "/" + encodeURIComponent(this.cv.resumeFileUrl);
    window.open(url);
  }
  changeCvConfig() {
    const param = {
      atsCvId: this.cv.atsCvId,
      canUpdateNrProject: this.cv.canUpdateNrProject,
      canUpdateNrAttachment: this.cv.canUpdateNrAttachment
    };
    request.post("/aiExam/atsAdmin/cvUpdateConfig", param).then(async resp => {
      if (resp.data.code === 0) {
        await this.getCv();
      }
    });
  }

  addWork() {
    const item = new NRWork();
    this.cv.cvWork.push(item);
  }

  delWork(i: any) {
    this.cv.cvWork.splice(i, 1);
  }

  addEducation() {
    const item = new NREducation();
    this.cv.cvEducation.push(item);
  }

  delEducation(i: any) {
    this.cv.cvEducation.splice(i, 1);
  }

  getFormatMonth(date: any) {
    return dayjs(date).format("YYYY.MM");
  }
  //保存过往案例
  async saveProject() {
    const editor = this.$refs["projectEditor"] as NRProjectEdit;
    const result = await editor.saveProject();
    if (result) {
      this.edit = false;
      this.editTab2 = false;
    }
  }
  //案例 保存后去空
  saveProjectResp(data: any) {
    const resp = new NRProject().assign(data.nrProject);
    this.cv.nrProject.caseList = resp.caseList;
    this.cv.nrProject.shortVideoList = resp.shortVideoList;
  }

  cancelEditProject() {
    this.editTab2 = false;
    this.cancelSaveResume();
  }
  //保存简历
  async saveResume() {
    (this.$refs.cvTitleForm as ElForm).validate(async (valid: any) => {
      if (valid) {
        if (!this.cvId && !this.cv.atsCvId) {
          const data = await this.cv.create(this.clientType);
          this.cv.atsCvId = data.atsCvId;
        } else {
          const data = await this.cv.edit(this.clientType);
        }
        this.getCv();
        this.edit = false;
      }
    });
  }

  async cancelSaveResume() {
    this.edit = false;
    if (this.cv.atsCvId) this.cv = await this.getCv();
    else this.closeModal();
  }

  showEdit() {
    this.edit = true;

    if (this.cv.cvEducation.length == 0) {
      this.cv.cvEducation.push(new NREducation());
    }

    if (this.cv.cvWork.length == 0) {
      this.cv.cvWork.push(new NRWork());
    }
  }

  closeModal() {
    this.$emit("close");
    //
  }

  async confirmRecommend() {
    await this.cv.setRecommend(this.recommendStatus, this.recommendMessage);
    this.showRecommendDialog = false;
    this.getCv();
  }

  async cancelRecommend(event: any, confirm = false) {
    console.log(this.cv.isNr);
    if (this.cv.isNr === 1 && !confirm) {
      this.showCancelRecommendDialog = true;
    } else {
      await this.cv.setRecommend(0, "");
      this.showRecommendDialog = false;
      this.getCv();
      this.showCancelRecommendDialog = false;
    }
  }

  get canRecommend() {
    return this.cv.candidate && this.cv.candidate.submitStatus == 2;
  }

  recommend() {
    this.recommendStatus = NRCandidate.RECOMMAND_STATUS.RECOMMEND;
    this.showRecommendDialog = true;
  }

  noRecommend() {
    this.recommendStatus = NRCandidate.RECOMMAND_STATUS.NOT_RECOMMEND;
    this.showRecommendDialog = true;
  }

  async enterInterview() {
    await this.cv.updateStatus(10);
    this.getCv();
  }

  get beforeUpload() {
    return true;
  }

  //上传成功回调
  async uploadSuccess(res: any) {
    this.showWarn = true;
    this.uploadedUrl = res.url;
    const position = this.cv.position;
    const positionType = this.cv.positionType;
    const atsCompanyId = this.cv.atsCompanyId;
    const cvId = this.cv.atsCvId;
    this.cv = await NRCandidate.parse(
      res.object,
      res.filename,
      this.clientType
    );
    this.cv.positionType = positionType;
    this.cv.position = position;
    this.cv.atsCompanyId = atsCompanyId;
    this.cv.atsCvId = this.cvId ? this.cvId : cvId;
    this.showUploadCv = false;
  }
  //打开报告页
  showReport() {
    window.open(this.cv.candidateReportUrl);
  }
  //打开阅卷页
  toMrak() {
    const previewUrl = `/exam/mark?connectCode=${this.cv.connectCode}`;
    window.open(previewUrl);
  }
  //查看大图
  openImg() {
    if (this.checkFileType(this.cv.resumeFileUrl)) {
      this.bigImgUrl =
        this.cv.ossPrefix + "/" + encodeURIComponent(this.cv.resumeFileUrl) ||
        "";
      this.showBigImg = true;
    } else {
      this.openResumeLink();
    }
  }
  //区分文件类型
  checkFileType(name: string) {
    if (["png", "PNG", "jpg", "JPG"].includes(name.slice(-3))) {
      return true;
    } else {
      return false;
    }
  }
}
